export default "__VITE_ASSET__e19eadc2__"